import api from "api";
import LayoutItem from "components/LayoutItem";
import React, { useState, useEffect } from "react";
import { Modal } from "reactstrap";
import { Button } from "shared";
import t, { getCurrentLanguage } from "utils/Lang";

type ModalCreateTabProps = {
  isOpen: boolean;
  toggle: (event?: React.KeyboardEvent<any>) => void;
  id?: number;
  user: any;
  onClosed: () => void;
  selectedTabId?: any;
  onCreated?: (data: any) => void;
  onUpdated?: (data: any) => void;
  onDeleted?: () => void;
};

const ModalCreateTab = ({
  isOpen,
  toggle,
  user,
  onClosed,
  selectedTabId,
  onCreated,
  onUpdated,
  onDeleted,
}: ModalCreateTabProps) => {
  const [tabData, setTabData] = useState<any>({
    content_type: "site",
    is_show: true,
    scope: "custom",
  });
  useEffect(() => {
    if (selectedTabId) fetchTabData();
  }, [selectedTabId]);
  const fetchTabData = async () => {
    const res = await api.getTabDetail(selectedTabId);
    if (res.status === "ok") {
      setTabData((data: any) => ({
        ...data,
        name: res?.studio_tab?.languages?.vi,
        name_en: res?.studio_tab?.languages?.en,
        is_show: res?.studio_tab?.is_show,
        scope: res?.studio_tab?.scope,
      }));
    }
  };
  const uiLayoutDefinition = [
    {
      attributeName: "brand",
      type: "text",
      data: user?.user_brand?.brand_name,
      label: "Brand",
      disabled: true,
    },
    {
      attributeName: "name",
      type: "text",
      label: "Tab name (*)",
    },
    {
      attributeName: "name_en",
      type: "text",
      label: "Tab name (en)",
    },
    {
      attributeName: "is_show",
      type: "check",
      label: "Show tab",
    },
  ];
  const onSave = async () => {
    if (!tabData.name) {
      alert("Tab name can not be empty");
      return;
    }
    const data: any = {
      content_type: tabData.content_type,
      languages: {
        vi: tabData.name,
        en: tabData.name_en,
      },
      is_show: tabData.is_show,
    };
    if (tabData.scope !== "system") {
      data.name = tabData.name;
    }
    if (selectedTabId) {
      const res = await api.updateTab(data, selectedTabId);
      onUpdated?.({
        name: data.languages[getCurrentLanguage() || "vi"],
        is_show: tabData.is_show,
      });
    } else {
      const res = await api.createTab(data);
      onCreated?.(res.studio_tab);
    }
    toggle();
  };

  const updateAtt = (att: string, val: any) => {
    let value = val;
    if (typeof val === "object") {
      if (val?.length > 0) {
        // good
      } else {
        value = val.value;
      }
    }
    setTabData((tabData: any) => {
      if (tabData) {
        return {
          ...tabData,
          [att]: value,
        };
      }
      return { [att]: value };
    });
  };

  const onDelete = async () => {
    const res = await api.updateTab({ is_active: false }, selectedTabId);
    if (res.status === 'ok') {
      onDeleted?.();
    } else if (res.message) {
      alert(res.message);
    }
    
    toggle();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{ padding: 30 }}
      onClosed={onClosed}
    >
      <div className="modal-custom-field__header">
        <span className="modal-custom-field__header__title">
          {selectedTabId
            ? t().modal_create_tab__edit_tab
            : t().modal_create_tab__create_tab}
        </span>
        <i className="material-icons btn-close" onClick={() => toggle()}>
          close
        </i>
      </div>
      <div className="modal-custom-field__body">
        {uiLayoutDefinition.map((item) => (
          <LayoutItem
            key={item.attributeName}
            item={item}
            statusData={tabData}
            callback={updateAtt}
          />
        ))}
      </div>
      <div className="modal-custom-field__footer">
        {selectedTabId && tabData.scope !== "system" && (
          <>
            <Button
              label={t().action__delete}
              onClick={onDelete}
              size="small"
              type="danger"
            />
            <div style={{ width: 10 }} />
          </>
        )}
        <Button
          label={t().action__done}
          onClick={onSave}
          size="small"
          type="primary"
        />
      </div>
    </Modal>
  );
};

export default ModalCreateTab;
